import { createSlice } from "@reduxjs/toolkit";

const lapSlice = createSlice({
  name: "lap",
  initialState: {
    projectId: null,
    data: null, // Holds the single LAP object
    list: [],
    loading: false,
    creating: false,
    updating: false,
    publishing: false,
    deleting: false,
    error: null,
  },
  reducers: {
    // FETCH SINGLE
    fetchLapRequest: (state, action) => {
      state.loading = true;
      state.error = null;
    if (state.projectId !== action.payload) {
        state.data = null; 
        state.list = [];
        state.projectId = action.payload; 
      }
    },
    fetchLapSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    fetchLapFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // FETCH LIST
    fetchLapsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchLapsSuccess: (state, action) => {
      state.loading = false;
      state.list = action.payload;
    },
    fetchLapsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // CREATE
    createLapRequest: (state) => {
      state.creating = true;
      state.error = null;
    },
    createLapSuccess: (state) => {
      state.creating = false;
    },
    createLapFailure: (state, action) => {
      state.creating = false;
      state.error = action.payload;
    },

    // UPDATE
    updateLapRequest: (state) => {
      state.updating = true;
      state.error = null;
    },
    updateLapSuccess: (state) => {
      state.updating = false;
    },
    updateLapFailure: (state, action) => {
      state.updating = false;
      state.error = action.payload;
    },

    // PUBLISH
    publishLapRequest: (state) => {
      state.publishing = true;
      state.error = null;
    },
    publishLapSuccess: (state) => {
      state.publishing = false;
    },
    publishLapFailure: (state, action) => {
      state.publishing = false;
      state.error = action.payload;
    },

    // DELETE
    deleteLapRequest: (state) => {
      state.deleting = true;
      state.error = null;
    },
    deleteLapSuccess: (state) => {
      state.deleting = false;
      state.data = null; // Clear it out on delete
    },
    deleteLapFailure: (state, action) => {
      state.deleting = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchLapRequest, fetchLapSuccess, fetchLapFailure,
  fetchLapsRequest, fetchLapsSuccess, fetchLapsFailure,
  createLapRequest, createLapSuccess, createLapFailure,
  updateLapRequest, updateLapSuccess, updateLapFailure,
  publishLapRequest, publishLapSuccess, publishLapFailure,
  deleteLapRequest, deleteLapSuccess, deleteLapFailure,
} = lapSlice.actions;

export default lapSlice.reducer;